import React, { useState, useRef, useEffect } from "react";
import "./ImageUpload.css";
import lion1 from "assets/lion_images/lion_image1.png";
import headshot from "assets/miscellaneous/upload_headshot_avatar.svg"; // Adjust the path accordingly

import number1 from "assets/icons/image_upload_number1_icon.svg";
import number2 from "assets/icons/image_upload_number2_icon.svg";

import {ReactComponent as UploadIcon} from "assets/icons/upload-icon.svg";
import { ReactComponent as CloseSymbol } from "assets/icons/close-symbol.svg";

function ImageUpload({
  options,
  imageUploadCallback,
  ethnicitySelectCallback,
  genderSelectCallback,
  onSkip,
  onContinueCallback,
}) {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(headshot); //TODO: need to check for headshot as default instead of empty image
  const [isImageModalOpen, setImageModalOpen] = useState(false);
  const [selectedEthnicity, setSelectedEthnicity] = useState("");
  const [selectedGender, setSelectedGender] = useState("");


  const handleEthnicityChange = (event) => {
    setSelectedEthnicity(event.target.value);
  };

  //trigger the formwizard callback when an option is select
  useEffect(() => {
    ethnicitySelectCallback(selectedEthnicity);
  }, [selectedEthnicity]);

  const handleGenderChange = (event) => {
    setSelectedGender(event.target.value);
  };

  //trigger the formwizard callback when an option is select
  useEffect(() => {
    genderSelectCallback(selectedGender);
  }, [selectedGender]);

  //trigger the formwizard callback when an image is uploaded
  useEffect(() => {
    if (uploadedImage != headshot) {
      imageUploadCallback(uploadedImage);
    }
  }, [uploadedImage]);

  const openModal = () => {
    setImageModalOpen(true);
  };

  const closeModal = () => {
    setImageModalOpen(false);
  };

  //* listen to user uploading new file
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    //validate the file based on open ai requirements
    if (file && (file.type === "image/png" ||  file.type === "image/jpeg") && file.size <= 4000000) {
      setSelectedFile(file);

      // Convert the uploaded image to base64
      const reader = new FileReader();
      reader.onload = (e) => {
        setUploadedImage(e.target.result);
        clearFileInput();
      };
      reader.readAsDataURL(file);
    } else {
      if(file){
        alert(`Please upload a .png or .jpeg image file - this file is a ${file.type}`);
      }
      //if file is null the user probably just closed the window
      setSelectedFile(null);
      setUploadedImage("");
      clearFileInput();
    }
  };

  const handleUploadClick = () => {
    // Programmatically trigger the hidden file input
    fileInputRef.current.click();
  };

  //click continue on modal to proceed to next step
  const handleContinue = () => {
    if (uploadedImage != headshot) {
      //TODO: add gtm data layer push for successful image upload and ethnicity
      window.dataLayer.push({
        event: "imageUploaded",
        ethnicity: selectedEthnicity,
      });
      onContinueCallback();
    }
  };

  const removeImage = () => {
    setUploadedImage(headshot);
    clearFileInput();
  }

  const clearFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <>
      {isImageModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button onClick={closeModal} className="close-button">
              <CloseSymbol/>
            </button>
            <div className="content">
              <h2>Upload Your Headshot</h2>
              <p>Using AI, let's bring your likeness into your photo.</p>
            </div>
            <div className="field-container">
              <div className="left">
                <h3 className="field-header">
                <img className="number" src={number1}></img>
                  Select your headshot from your device.
                </h3>
                <p>
                  Make sure your head and shoulders are clearly visible. Don't
                  worry, we aren't storing your image.
                </p>
                {uploadedImage != headshot ? (
                  <div className="inherit svg-bump">
                    <p className="filename">{selectedFile ? selectedFile.name : ""}</p>
                    <button
                      onClick={removeImage}
                      className="remove-file-btn"
                    >
                      Remove Image
                    </button>
                  </div>
                ) : (
                  <>
                    <button
                      className="choose-image-button"
                      onClick={handleUploadClick}
                    >
                      Choose Image
                    </button>
                    <p className="image-requirements">
                      Please upload a PNG or JPEG image.  For the bot to work, your image must be square and no
                      larger than 4MB.
                    </p>
                  </>
                )}
              </div>

              <img
                className="headshot"
                src={uploadedImage}
                alt="Uploaded Headshot"
              />
            </div>
            <div className="field-container">
              <div>
                <div className="left">
                  <h3 className="field-header">
                    <img className="number" src={number2}></img>
                    Select your ethnicity and gender identity (optional)
                  </h3>
                  <p>
                    Since we are using new AI technology, it's not perfect. If
                    we have your ethnicity and gender identity, it might help us generate a more
                    accurate image.
                  </p>
                  <select
                    className="select-ethnicity"
                    id="ethnicity"
                    value={selectedEthnicity}
                    onChange={handleEthnicityChange}
                  >
                    <option value="">Select Your Ethnicity</option>
                    {options.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <select
                    className="select-gender-identity"
                    id="gender-identity"
                    value={selectedGender}
                    onChange={handleGenderChange}
                  >
                    <option value="">Select Your Gender Identity</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Non-Binary">Non-Binary</option>
                  </select>
                  <button
                    className="image-upload-continue"
                    onClick={handleContinue}
                    disabled={uploadedImage === headshot}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="image-options">
        <div className="option-container">
          <div className="option-image-container">
            <img src={lion1} alt="Image 1" />
            <a className="primary button data-gtm-gus" onClick={onSkip}>
              I'll stick with Gus
            </a>
          </div>
          <p className="hidden-text">
            Meet our mascot Gus the Lion. We call ourselves "Gusties."
          </p>
        </div>
        <div className="option-container">
          <div className="option-image-container">
            <img
              className="headshot"
              src={uploadedImage}
              alt="Upload Headshot"
            />
            <a
                className="primary button data-gtm-headshot icon-upload"
                onClick={() => openModal()}
            >
              Upload&nbsp;headshot <span>
              <UploadIcon />
              </span>
            </a>
          </div>
          <p className="hidden-text">
            Don't worry, we aren't storing your image.
          </p>
        </div>
      </div>
      <div className="image-upload">
        <input
            type="file"
            ref={fileInputRef}
            style={{display: "none"}}
            onChange={handleFileChange}
            accept="image/png;image/jpeg;"
        />
      </div>
    </>
  );
}

export default ImageUpload;
